import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.assign.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = ["id", "data-cy"];
import { computed, reactive, useAttrs, watch, onBeforeMount } from "vue";
import { isEmptyObject } from "@utils/ObjectUtils";
import checkboxBtn from "@vueEntry/UIKitComponents/Checkbox/CheckboxBtn.vue";
import { stringToHyphened } from "@utils/StringUtils";
export default /*#__PURE__*/_defineComponent(Object.assign({
  inheritAttrs: false
}, {
  __name: 'CheckboxGroup',
  props: {
    valuesObj: {
      default() {
        return {};
      }
    },
    formCheckInline: {
      type: Boolean,
      default: false
    },
    customClass: {
      default: ""
    },
    reset: {
      type: Boolean,
      default: false
    },
    autoCheckResetAll: {
      type: Boolean,
      default: false
    },
    autoCheckResetEmpty: {
      type: Boolean,
      default: false
    },
    getKey: {
      default() {
        return checkBtn => checkBtn.id;
      }
    }
  },
  emits: ["resetted", "update:modelValue", "checkedGroup"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    //@ts-ignore
    var attrs = useAttrs();
    var props = __props;
    var emits = __emit;
    var state = reactive({
      checkedValuesObj: {}
    });
    var resetCheckbox = computed(() => {
      for (var k in props.valuesObj) {
        var v = props.valuesObj[k];
        if (v.reset) return v;
      }
      return null;
    });
    var checkboxesLength = computed(() => Object.keys(props.valuesObj).length);
    var selectedCheckboxesLength = computed(() => Object.values(state.checkedValuesObj).reduce((acc, cur) => cur.checked ? acc + 1 : acc, 0));
    watch(() => props.reset, cur => {
      if (!cur) return;
      resetCheckboxes();
      emits("resetted");
    });
    onBeforeMount(() => {
      //Initializing the selected checkbox object so the state and the props match
      for (var k in props.valuesObj) {
        var v = props.valuesObj[k];
        v.checked = !!v.checked;
        state.checkedValuesObj[k] = v;
      }
    });
    var resetCheckboxes = () => {
      for (var k in state.checkedValuesObj) {
        state.checkedValuesObj[k].checked = false;
      }
    };
    var isActive = elem => {
      return state.checkedValuesObj[props.getKey(elem)].checked;
    };
    var handleChange = checkboxValue => {
      state.checkedValuesObj[checkboxValue.id].checked = !isActive(checkboxValue);
    };
    var handleCheckboxChange = checkboxValue => {
      if (!props.valuesObj || isEmptyObject(props.valuesObj)) return;
      //If we have a checkbox reset button, we have to clean all the selected checkboxes
      if (props.valuesObj[checkboxValue.id].reset && checkboxValue.checked) {
        resetCheckboxes();
      }
      //If we check any other checkbox, we have to uncheck the reset one
      else if (resetCheckbox.value && !props.valuesObj[checkboxValue.id].reset) {
        state.checkedValuesObj[props.getKey(resetCheckbox.value)].checked = false;
      }
      //Toggling the checkbox
      state.checkedValuesObj[checkboxValue.id].checked = !!checkboxValue.checked;
      //Edge case 1: If I check all the button but the one with reset, all the other checkboxes will be deselected but the one with reset
      if (props.autoCheckResetAll && resetCheckbox.value && selectedCheckboxesLength.value === checkboxesLength.value - 1) for (var k in state.checkedValuesObj) {
        state.checkedValuesObj[k].checked = !!state.checkedValuesObj[k].reset;
      }
      //Edge case 2: If uncheck all the checkboxes, we will check the reset button
      if (props.autoCheckResetEmpty && resetCheckbox.value && !selectedCheckboxesLength.value) state.checkedValuesObj[props.getKey(resetCheckbox.value)].checked = true;
      //Returning the checked labels
      emits("update:modelValue", Object.values(state.checkedValuesObj).filter(c => c.checked));
      emits("checkedGroup", attrs["group-id"] || "");
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: _ctx.$attrs['group-id'] || '',
        class: _normalizeClass(["checkbox-group-container", _ctx.$attrs['class'] || '']),
        "data-cy": _ctx.$attrs['data-cy'] || ''
      }, [_renderSlot(_ctx.$slots, "checkboxElement", {
        isActive: isActive,
        handleChange: handleChange
      }, () => [_ctx.valuesObj ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(_ctx.valuesObj, (value, _, idx) => {
        return _openBlock(), _createBlock(checkboxBtn, {
          id: _ctx.getKey(value),
          key: idx,
          "data-cy": "checkbox_".concat(_unref(stringToHyphened)(value.label)),
          label: value.label,
          inline: _ctx.formCheckInline,
          "wrapper-margin-y": _ctx.$attrs['checkbox-padding-y'],
          "model-value": isActive(value),
          onChange: handleCheckboxChange
        }, null, 8 /* PROPS */, ["id", "data-cy", "label", "inline", "wrapper-margin-y", "model-value"]);
      }), 128 /* KEYED_FRAGMENT */)) : _createCommentVNode("v-if", true)])], 10 /* CLASS, PROPS */, _hoisted_1);
    };
  }
}));